import { api } from '@/core/api/';
const apiUrl = 'api/inventorycatalog';

export default {
  addCatalog(data) {
    return api.post(apiUrl, data);
  },
  getCatalog(id) {
    return api.get(`${apiUrl}/${id}`);
  },
  addAccessories(id, data) {
    return api.post(`${apiUrl}/${id}/accessories`, data);
  },
  getAccessories(id) {
    return api.get(`${apiUrl}/${id}/accessories`);
  },
  getAccessoryLocations(detailId, currentPage, pageSize) {
    return api.get(
      `${apiUrl}/accessories/detail/${detailId}/locations/${currentPage}/${pageSize}`
    );
  },
  addAccessoryQuantity(detailId, quantity) {
    return api.patch(
      `${apiUrl}/accessories/detail/${detailId}/quantity/${quantity}`
    );
  },
  addProperties(id, data) {
    return api.post(`${apiUrl}/${id}/properties`, data);
  },
  getProperties(id) {
    return api.get(`${apiUrl}/${id}/properties`);
  },
  getColors() {
    return api.get(`${apiUrl}/codes/colors`);
  },
  getStatusSummary(id) {
    return api.get(`${apiUrl}/${id}/statussummary`);
  },
  getFilterOptions(classificationId) {
    return api.get(`${apiUrl}/filteroptions/${classificationId}`);
  },
  search(params) {
    return api.get(`${apiUrl}/search`, { params });
  },
  getSearchEquipments(id, recommendationId, params) {
    return api.post(`${apiUrl}/${id}/${recommendationId}/equipments`, params);
  },
  getSearchEquipmentsSummary(id, recommendationId, params) {
    return api.post(
      `${apiUrl}/${id}/${recommendationId}/equipments/summary`,
      params
    );
  },
  getInventoryManagementFilters(id) {
    return api.get(`${apiUrl}/${id}/inventorymanagementfilters`);
  },
  getCatalogModels(id, brandId) {
    return api.get(`${apiUrl}/${id}/models/${brandId}`);
  },
  saveEquipment(data) {
    return api.post(`${apiUrl}/saveequipment`, data);
  },
  getAllEquipments() {
    return api.get(`${apiUrl}/equipments`);
  },
  getAllCatalogs() {
    return api.get(`${apiUrl}/catalogs`);
  },
  getAllEquipmentsRequested() {
    return api.get(`${apiUrl}/equipments/requested`);
  },
  getAccessoriesByEquipment(id, currentPage, pageSize) {
    return api.get(
      `${apiUrl}/equipment/${id}/accessories/${currentPage}/${pageSize}`
    );
  },
  getAssignedAccessoriesByEquipment(id) {
    return api.get(`${apiUrl}/equipment/${id}/accessories/assigned`);
  },
  getEquipmentStatus() {
    return api.get(`${apiUrl}/codes/equipmentstatus`);
  },
  assignEquipment(data) {
    return api.post(`${apiUrl}/assignequipment/`, data);
  },
  unassignEquipment(id) {
    return api.post(`${apiUrl}/equipment/${id}/unassign`);
  },
  saveInventoryTransfer(id, data) {
    return api.post(`${apiUrl}/equipment/${id}/transfer`, data);
  },
  getTransferStatuses() {
    return api.get(`${apiUrl}/codes/transferstatuses`);
  },
  cancelInventoryTransfer(id, data) {
    return api.patch(`${apiUrl}/equipment/${id}/transfer/cancel`, data);
  },
  approveInventoryTransfer(id, data) {
    return api.patch(`${apiUrl}/equipment/${id}/transfer/approve`, data);
  },
  rejectInventoryTransfer(id, data) {
    return api.patch(`${apiUrl}/equipment/${id}/transfer/reject`, data);
  },
  sendToRouteInventoryTransfer(id, data) {
    return api.patch(`${apiUrl}/equipment/${id}/transfer/sendtoroute`, data);
  },
  searchTranfers(params) {
    return api.get(`${apiUrl}/transfer/search`, { params });
  },
  getInventoryTransferInfo(id) {
    return api.get(`${apiUrl}/equipment/${id}/transfer`);
  },
  getTransferInfo(id) {
    return api.get(`${apiUrl}/${id}/transfer`);
  },
  getTransferAdditionalInfo(id) {
    return api.get(`${apiUrl}/transfer/${id}/additionalinfo`);
  },
  confirmInventoryTransfer(id, data) {
    return api.put(`${apiUrl}/equipment/${id}/transfer/confirm`, data);
  },
  getTransferHistory(id) {
    return api.get(`${apiUrl}/${id}/transfer/log`);
  },
  getEquipmentDetails(id) {
    return api.get(`${apiUrl}/equipments/${id}`);
  },
  getEquipmentLoanDetails(id) {
    return api.get(`${apiUrl}/equipment/${id}/loan`);
  },
  getEquipmentTransferHistory(id) {
    return api.get(`${apiUrl}/${id}/equipmenttransfer/log`);
  },
  assignCaatToEquipment(ids, caatId) {
    return api.patch(`${apiUrl}/equipment/caat/${caatId}`, ids);
  },
  getAssignmentHistory(id) {
    return api.get(`${apiUrl}/equipment/${id}/assignmenthistory`);
  },
  markAvailable(id) {
    return api.put(`${apiUrl}/${id}/equipment/markavailable`);
  },
  inactiveEquipment(id) {
    return api.post(`${apiUrl}/equipment/${id}/inactive`);
  },
  eliminateEquipment(id) {
    return api.post(`${apiUrl}/equipment/${id}/eliminate`);
  },
  editEquipment(id, data) {
    return api.put(`${apiUrl}/equipment/${id}/edit`, data);
  },
  applyActionToEquipments(action, data) {
    return api.post(`${apiUrl}/equipments/${action}/apply`, data);
  },
  loanEquipment(data) {
    return api.post(`${apiUrl}/loanequipment/`, data);
  },
  nofityLoanExtensionDate(data) {
    return api.post(`${apiUrl}/nofityloanextensiondate/`, data);
  },
  getStudents(query) {
    return api.get(`${apiUrl}/searchstudents?query=${query}`);
  },
  getTypeFacilities() {
    return api.get(`${apiUrl}/typefacilities`);
  },
  addEquipmentBinnacle(id, data) {
    return api.post(`${apiUrl}/equipment/${id}/binnacle`, data);
  },
  getEquipmentBinnaclesHistory(equipmentId) {
    return api.get(`${apiUrl}/equipment/${equipmentId}/binnacles`);
  },
  getDocumentsToConfiscate(equipmentId) {
    return api.get(`${apiUrl}/equipment/${equipmentId}/documentstoconfiscate`);
  },
  consfiscateEquipment(data) {
    return api.post(`${apiUrl}/seizeequipment`, data);
  },
  getStudentFromLoan(equipmentId) {
    return api.get(`${apiUrl}/equipment/${equipmentId}/student`);
  },
  getInititalReturnDate(equipmentId) {
    return api.get(`${apiUrl}/equipment/${equipmentId}/inititalreturndate`);
  },
  notifyReturnDate(data) {
    return api.post(`${apiUrl}/equipment/savereturndate`, data);
  },
  getEquipmentLoanReturnDetails(equipmentId) {
    return api.get(`${apiUrl}/equipment/${equipmentId}/returndetails`);
  },
  getEquipmentReport(equipmentId) {
    return api.get(`${apiUrl}/equipment/${equipmentId}/ageguarantee`);
  },
};
